export class ImportResource {
  Title: string;
  PlaceHolder: string;
  ValidationMessage: string;
  Hint: string;
  ToolTip: string;
  S: string;
}
